// Copyright (c) 2016 Deere & Company

import RegistrationsReview from '@deere/cps-it.warranty-model-factory/lib/registrations-review';
import t from 'tcomb';

const Report = t.list(RegistrationsReview, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;




// WEBPACK FOOTER //
// ./src/reports/registrations-review/state/report.js